import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { getAllPermissions } from '../../../api/user/list-all-permissions'

export const initialState = {
  isFetchingAllPermissions: false,
  allPermissions: [],
  fetchAllPermissionsError: null,
}

export const fetchAllPermissions = createAsyncThunk(
  'viewPermission/fetchAllPermissions',
  async (args, { rejectWithValue }) => {
    try {
      const response = await getAllPermissions()
      return response?.data?.data
    } catch (exception) {
      return rejectWithValue(exception)
    }
  },
)

const viewPermissionSlice = createSlice({
  name: 'viewPermission',
  initialState,
  reducers: {
    resetViewPermissionSlice() {
      return initialState
    },
    resetFetchAllPermissionsError(state) {
      state.fetchAllPermissionsError = null
    },
  },
  extraReducers: (builder) => {
    builder
      /* Fetching All Permissions */
      .addCase(fetchAllPermissions.pending, (state) => {
        state.isFetchingAllPermissions = true
        state.allPermissions = []
        state.fetchAllPermissionsError = null
      })
      .addCase(fetchAllPermissions.fulfilled, (state, action) => {
        state.isFetchingAllPermissions = false
        state.allPermissions = action.payload
      })
      .addCase(fetchAllPermissions.rejected, (state, action) => {
        state.isFetchingAllPermissions = false
        state.fetchAllPermissionsError = action.payload
      })
      /* Action which gets triggered
         when running persistor.purge() */
      .addCase(PURGE, () => {
        return initialState
      })
  },
})

export const { resetViewPermissionSlice, resetFetchAllPermissionsError } =
  viewPermissionSlice.actions

export default viewPermissionSlice.reducer
